<template>

	<div class="districtLocatorMapContainer">
		<object data="/dist/img/svg/FC_District_Map.svg" type="image/svg+xml"><img src="/dist/img/svg/FC_District_Map.svg" /></object>
	</div>
	
</template>

<script>
	
	export default {
		name: 'DistrictLocatorMap'
	}
	
</script>